// total.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { BarChartComponent } from '../bar-chart.component';
import { GroupedBarChartComponent } from '../bar-chart/grouped-bar-chart.component';
import { DoughnutChartComponent } from '../doughnut-chart/doughnut-chart.component';
import { GaugeChartComponent } from '../gauge-chart/gauge-chart.component';
import { LegendComponent } from '../legend/legend.component';
import { OptionsComponent } from '../options/options.component';
import { ModalService } from '../../../../services/modal.service';

@Component({
  standalone: true,
  selector: 'app-total',
  templateUrl: './total.component.html',
  styleUrls: ['./total.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    BarChartComponent,
    DoughnutChartComponent,
    GaugeChartComponent,
    GroupedBarChartComponent,
    OptionsComponent,
    LegendComponent,
    TotalComponent,
  ],
})
export class TotalComponent {
  @Input() barChartDatasets: any[];
  @Input() barChartLabels: string[];
  @Input() doughnutChartDatasets: any[];
  @Input() doughnutChartLabels: string[];
  @Input() doughnutChartInfoComplete: string;
  @Input() doughnutChartInfoIncomplete: string;
  @Output() exportCommands = new EventEmitter<'complete' | 'incomplete'>();
  @Output() viewCommands = new EventEmitter<'complete' | 'incomplete'>();

  constructor(private modal: ModalService) {}

  download_commands(slice: 'complete' | 'incomplete') {
    this.exportCommands.emit(slice);
  }

  download_completed_commands(slice: 'complete' | 'incomplete') {
    this.viewCommands.emit(slice);
  }

  barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: { beginAtZero: true },
      x: { grid: { display: false } },
    },
    plugins: {
      legend: { display: true },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (ctx: any) => ctx.dataset.data[ctx.dataIndex] ? ctx.dataset.label : '',
        },
      },
    },
  };

  doughnutChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
  };
}
